<style>
    table, th, td{
         border: solid 1px rgba(40,40,40,0.2);
         font-size:14px;
         padding:5px;
     }
     table{
         width: 100%;
     }
 </style>
<div class="row">
    <div class="col-12">
        <h2>Bolsas Térmicas</h2>
    </div>
    <div class="col-12">
        <table id="myTable">
            <tr class="header">
              <th style="width:50%;"><t1>Artículo</t1></th>
              <th style="width:10%;"><t1>Código</t1></th>
              <th style="width:40%;"><t1>Medidas</t1></th>
            </tr>
            <tr>
              <td><t2>Bolsas Térmicas 20x20</t2></td>
              <td><t2>BT001</t2></td>
              <td><t2>Boca: 20cm, Largo: 20cm</t2></td>
            </tr>
            <tr>
                <td><t2>Bolsas Térmicas 20x30</t2></td>
                <td><t2>BT002</t2></td>
                <td><t2>Boca: 20cm, Largo: 30cm</t2></td>
              </tr>
              <tr>
                <td><t2>Bolsas Térmicas 20x35</t2></td>
                <td><t2>BT003</t2></td>
                <td><t2>Boca: 20cm, Largo: 35cm</t2></td>
              </tr>
              <tr>
                <td><t2>Bolsas Térmicas 30x35</t2></td>
                <td><t2>BT004</t2></td>
                <td><t2>Boca: 30cm, Largo: 35cm</t2></td>
              </tr>
          </table>
    </div>
</div>